import { FieldValues } from 'react-hook-form';
import { Parser } from 'expr-eval-fork';

const normalizeValues = (formValues: FieldValues): FieldValues => {
  return Object.fromEntries(
    Object.entries(formValues).map(([key, value]) => [
      key,
      Array.isArray(value) ? JSON.stringify(value) : value,
    ]),
  );
};

export const parseConditional = (
  condition: string | undefined,
  formValues: FieldValues,
): boolean => {
  if (!condition) return false;
  try {
    const parser = new Parser();
    const expr = parser.parse(condition);
    return !!expr.evaluate(normalizeValues(formValues));
  } catch {
    return false;
  }
};
